import React from "react";
import SummerCart from '../components/SummerCart'
export default function FoodCartMenu(){
    return(
        <><SummerCart/></>)
}